import BaseService from "../BaseService";
import _ from "lodash";

class ProductVariantService extends BaseService {
    update = async ({ id, options, variants }) => {
        var data = await this._api.post("/product_variant/update", { id, options, variants });
        return data;
    };

    updatePriceList = async ({ variants }) => {
        var data = await this._api.post("/product_variant/update_pricelist", {  variants });
        return data;
    };


    list = async ({}) => {
        var data = await this._api.post("/product_variant/list", { });
        return data;
    };


  



}
export default ProductVariantService;
